export function isLocalDev() {
  return import.meta.env.DEV;
}

export function getBasePathWithTrailingSlash() {
  return import.meta.env.BASE_URL;
}

export function isMockApiEnabled() {
  return import.meta.env.VITE_MOCK_API_ENABLED === "true";
}

export function getBasePathWithoutTrailingSlash() {
  return getBasePathWithTrailingSlash().replace(/\/$/, "");
}
